import { render, staticRenderFns } from "./CallAscenti.vue?vue&type=template&id=0c31b72a&"
import script from "./CallAscenti.vue?vue&type=script&lang=js&"
export * from "./CallAscenti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports